import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { NeedHelpComponent } from 'app/shared/components/need-help/need-help.component';
import { AuthService } from 'app/shared/service/auth.service';
import { environment } from 'environments/environment.prod';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [MatIconModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
})
export class HeaderComponent implements OnInit, OnDestroy {
  private routerSubscription!: Subscription;
  readonly dialog = inject(MatDialog);
  readonly router = inject(Router);
  private authService = inject(AuthService);
  admin = window.location.pathname.split('/')[1] === 'admin';
  espaceClient = false;
  aide = false;
  ngOnInit(): void {
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const path = event.urlAfterRedirects.split('/')[1] || '';
        this.espaceClient = ['', 'preamble', 'type', 'result'].includes(path);
        this.aide = ['', 'preamble', 'type'].includes(path);
      });

    // Appel initial pour les cas de rechargement
    const path = this.router.url.split('/')[1] || '';
    this.espaceClient = ['', 'preamble', 'type', 'result'].includes(path);
    this.aide = ['', 'preamble', 'type'].includes(path);
  }
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
  logout() {
    this.authService.logout();
  }
  redirectSite() {
    window.open(environment.host);
  }
  openDialog(): void {
    this.dialog.open(NeedHelpComponent);
  }
  redirectEspaceClient() {
    this.router.navigate(['/login']);
  }
}
